import { useEffect, useState, useRef } from "react";
import { Bell, UserPlus, Link2, Check, MessageSquare, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { timeAgo } from "@/lib/razorpay";
import { useAuth } from "@/context/AuthContext";

const ICONS = { follow: UserPlus, connection_request: Link2, connection_accepted: Check, comment: MessageSquare, message: MessageCircle };

export const NotificationsBell = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data.items); setUnread(data.unread); } catch (e) { console.error("Failed to load notifications", e); }
  };
  const loadCount = async () => {
    try { const { data } = await api.get("/notifications/unread-count"); setUnread(data.unread); } catch (e) { console.error("Failed to load unread count", e); }
  };

  useEffect(() => {
    if (!user) return;
    loadCount();
    const t = setInterval(loadCount, 30000);
    return () => clearInterval(t);
  }, [user]);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) { await load(); await api.post("/notifications/read-all").catch((e) => console.error("Failed to mark read", e)); setUnread(0); }
  };

  if (!user) return null;

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notifications-bell" onClick={toggle} className="relative p-2 text-slate-600 hover:text-brand transition-colors">
        <Bell size={20} />
        {unread > 0 && <span data-testid="notifications-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">{unread > 9 ? "9+" : unread}</span>}
      </button>
      {open && (
        <div data-testid="notifications-panel" className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-white border border-slate-200 rounded-xl shadow-xl z-50">
          <div className="px-4 py-3 border-b border-slate-100 font-display font-bold text-slate-900">Notifications</div>
          {items.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-slate-400">No notifications yet</p>
          ) : items.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <div key={n.id} className={`px-4 py-3 flex gap-3 border-b border-slate-50 ${!n.read ? "bg-brand-light/40" : ""}`}>
                <div className="h-8 w-8 rounded-full bg-brand-light flex items-center justify-center shrink-0"><Icon size={15} className="text-brand" /></div>
                <div className="min-w-0"><p className="text-sm text-slate-700">{n.message}</p><p className="text-xs text-slate-400 mt-0.5">{timeAgo(n.created_at)}</p></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
